module.exports = __webpack_public_path__ + "static/media/bch.274d44f0.svg";